import React, { useEffect, useRef, useState } from "react";

import imgSabotSupanova from "../../assets/png/imgSabotSupanova.png";
import imgVictorOtaviano from "../../assets/png/imgVictorOtaviano.png";
import imgAnaHickamn from "../../assets/png/imgAnaHickamn.png";
import imgEstudioGuto from "../../assets/png/imgEstudioGuto.png";
import imgNewEra from "../../assets/png/imgNewEra.png";
import imgIdeaZarvos from "../../assets/png/imgIdeaZarvos.png";
import imgSportNutrition from "../../assets/png/imgSportNutrition.png";
import imgBodyAction from "../../assets/png/imgBodyAction.png";
import imgMobly from "../../assets/png/imgMobly.png";
import imgMonsterEnergy from "../../assets/png/imgMonsterEnergy.png";
import imgSociro from "../../assets/png/imgSociro.png";
import imgHighBurgerGta from "../../assets/png/imgHighBurgerGta.png";
import imgRaphaBridi from "../../assets/png/imgRaphaBridi.png";
import imgKarenOlimpio from "../../assets/png/imgKarenOlimpio.png";
import imgRexona from "../../assets/png/imgRexona.png";
import imgKing from "../../assets/png/imgKing.png";
import imgFelipeCamargo from "../../assets/png/imgFelipeCamargo.png";
import imgMaiale from "../../assets/png/imgMaiale.png";
import logoBackground from "../../assets/svg/logoBackground.svg";
import textoFilmesBackground from "../../assets/svg/textoFilmesBackground.svg";
import imgOGol from "../../assets/png/imgOGol.png";
import imgAirmaxDay from "../../assets/png/imgAirmaxDay.png";
import imgSomosInter from "../../assets/png/imgSomosInter.png";
import imgJohnnieWalker from "../../assets/png/imgJohnnieWalker.png";
import "./index.css";
import Header from "../Header";
import ScrollAnimado from "../ScrollAnimado";

import ModalVideo from "../ModalVideo";
import Footer from "../Footer";

export default function Projetos() {
  const videoRef = useRef(null);

  const [linkVideo, setLinkVideo] = useState("");

  return (
    <>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />

      <div className="w-100 h-100 position-relative">
        <Header />
        <div className="divCapaTodosProjetos">
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center">
              <img
                className="logoBackground"
                src={logoBackground}
                alt="capa do projeto"
              />
            </div>
            <div className="col-md-6 d-flex d-md-none">
              <img
                className="textoFilmesBackgroundCimaFixo"
                src={textoFilmesBackground}
                alt="capa do projeto"
              />
            </div>
          </div>
          <img
            className="textoFilmesBackgroundCima d-md-flex d-none"
            src={textoFilmesBackground}
            alt="capa do projeto"
          />
          <img
            className="textoFilmesBackgroundBaixo d-md-flex d-none"
            src={textoFilmesBackground}
            alt="capa do projeto"
          />
          {/* <ScrollAnimado /> */}
        </div>
      </div>
      {/* /////////////////        PROJETOS          /////////////////// */}
      <div className="divCapaTodosProjetos  overflow-hidden ">
        <div className="row d-flex align-items-center justify-content-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1144914091?h=83fc2d4218"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0px 0 24px 25%" }}
            >
              <img src={imgOGol} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                O Gol
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1090115482?h=6c80b503a9"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 25% 0" }}
            >
              <img src={imgAirmaxDay} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                Airmax Day
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1113627367?h=d554bc20f2"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "25% 0 0 0" }}
            >
              <img src={imgSomosInter} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Somos Inter
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1077944931?h=42be6d6f53"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "24px 0 24px 25%" }}
            >
              <img src={imgJohnnieWalker} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Johnnie Walker
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex flex-md-row flex-column-reverse align-items-center">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 0 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1031171359?h=87e2cc7646"
                );
              }}
            >
              <img src={imgKing} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                King
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-end flex-md-row flex-column-reverse align-items-center">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "-30% 0 0 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1046527428?h=564fecccab"
                );
              }}
            >
              <img src={imgMaiale} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Maiale
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-start flex-md-row flex-column-reverse align-items-center">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "24px 0 0px 25%" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/903101691?h=87e2cc7646"
                );
              }}
            >
              <img src={imgFelipeCamargo} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Felipe Camargo
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex flex-md-row flex-column-reverse align-items-center">
          <div className="row d-flex align-items-center justify-content-center"></div>

          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "20% 0 0 0" }}
              onClick={(e) => {
                setLinkVideo(
                  "https://player.vimeo.com/video/903084634?h=e1b93e22d8"
                );
              }}
            >
              <img src={imgKarenOlimpio} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Karen Olimpio
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 0 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/903102536?h=87e2cc7646"
                );
              }}
            >
              <img src={imgRaphaBridi} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Rafa Bridi
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801311?h=5e1ac78efc"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "50% 0 0 0" }}
            >
              <img src={imgSportNutrition} alt="capa do projeto" />

              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                Sport Nutrition
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/797771115?h=875c0628ce"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "-50% 0 0 0" }}
            >
              <img src={imgBodyAction} alt="capa do projeto" />

              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                Bodycation
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center justify-content-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801440?h=c04a5785de"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "24px 0 24px 25%" }}
            >
              <img src={imgMobly} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                Mobly
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801590?h=2eed9c6f58"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 25% 0" }}
            >
              <img src={imgMonsterEnergy} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center   d-flex d-md-none">
                Monster Energy
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801504?h=d08d1a0f73"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "25% 0 0 0" }}
            >
              <img src={imgSociro} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Sóciro / Unfinished Festival
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801384?h=97a89d41a0"
                );
              }}
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "24px 0 24px 25%" }}
            >
              <img src={imgHighBurgerGta} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                High Burger GTA
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "25% 0 0 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/367344666?h=f34bafdd90"
                );
              }}
            >
              <img src={imgSabotSupanova} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Sabot X Supanova
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 25% 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/726224751?h=fbd573cabf"
                );
              }}
            >
              <img src={imgVictorOtaviano} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Victor Otaviano feat. Catarse
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center justify-content-start">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "24px 0 12px 33%" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/726822084?h=3ef72574e0"
                );
              }}
            >
              <img src={imgAnaHickamn} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Casa vogue feat. Ana Hickamn
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "12px 0 24px 66%" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/726220528?h=4330e0741d"
                );
              }}
            >
              <img src={imgEstudioGuto} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Estúdio Guto Requena feat. Chandon
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "0 0 25% 0" }}
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/726221424?h=1dc6b08298"
                );
              }}
            >
              <img src={imgNewEra} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                New Era Inverno 22
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="capaTodosProjetos d-flex flex-column w-100"
              style={{ margin: "25% 0 0 0" }}
              onClick={(e) => {
                setLinkVideo(
                  "https://player.vimeo.com/video/726223765?h=c928978b92"
                );
              }}
            >
              <img src={imgIdeaZarvos} alt="capa do projeto" />
              <div className="tituloCardTodosProjetos text-center  d-flex d-md-none">
                Idea Zarvos feat A.R Arquiteros
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
